export default __webpack_public_path__ + "2023 Antenna-coupled infrared nanospectroscopy of intramolecular vibrational interaction.pdf";